export enum InjectionResponseStatus {
  "ACTIVE" = "ACTIVE",
  "INACTIVE" = "INACTIVE",
}
